<flo-article-list-view
  [articleList]="articles$ | async"
  (showMoreArticles)="showMore()"
></flo-article-list-view>
